import { useTranslation } from "react-i18next";
import Center from "../Base/Center";
import Button from "../Button/Button";
import Icon from "../Icon/Icon";
import {
  useReadSplitPaymentOrdersState,
  useSetSplitPaymentOrdersState,
} from "@/shared/atoms/useSplitPaymentV2Atom";

const MIN_SPLIT_COUNT = 2;

const SplitPaymentCount = () => {
  const { t } = useTranslation();
  const { paymentLedgers, splitCount } = useReadSplitPaymentOrdersState();
  const setSplitPaymentStates = useSetSplitPaymentOrdersState();

  const paidLedgerCount = paymentLedgers.filter((p) => p.is_paid).length;
  const minSplitCount = Math.max(MIN_SPLIT_COUNT, paidLedgerCount);
  const isDecreaseDisabled = splitCount - 1 < minSplitCount;

  const handleDecrease = () => {
    if (isDecreaseDisabled) return;
    setSplitPaymentStates({ splitCount: splitCount - 1 });
  };

  const handleIncrease = () => {
    setSplitPaymentStates({ splitCount: splitCount + 1 });
  };

  const buttonClasses =
    "group flex shrink-0 items-center justify-center size-14 lg:size-16 rounded-full shadow-sm hover:shadow-md active:scale-95 disabled:border-border disabled:shadow-sm disabled:active:scale-100";

  const iconClasses =
    "size-5 lg:size-7 fill-white transition-colors duration-200 group-hover:fill-white group-disabled:fill-white";

  return (
    <div className="flex flex-col items-center gap-1 md:gap-2 w-full md:w-auto">
      <span className="text-sm lg:text-base font-medium uppercase tracking-wide text-text-secondary">
        {t("posOrders.numberOfParts")}
      </span>
      <Center className="gap-2 lg:gap-4 p-2 rounded-full bg-grey border border-border/60 shadow-inner">
        <Button
          variant="default"
          size="icon"
          aria-label={t("price_popup.decrease")}
          isDisabled={isDecreaseDisabled}
          onClick={handleDecrease}
          className={buttonClasses}
        >
          <Icon className={iconClasses} variants="minus" />
        </Button>
        <p className="min-w-12 md:min-w-16 text-center text-3xl lg:text-5xl font-bold tabular-nums select-none text-dark">
          {splitCount}
        </p>
        <Button
          variant="default"
          size="icon"
          aria-label={t("price_popup.increase")}
          onClick={handleIncrease}
          className={buttonClasses}
        >
          <Icon className={iconClasses} variants="plus" />
        </Button>
      </Center>
    </div>
  );
};

export default SplitPaymentCount;
